'use client'

import React, { useId } from 'react'
import { useTranslations } from 'next-intl'
import { Paragraph } from '../../atoms/Typography/Typography.component'
import Button from '../../atoms/Button/Button.component'
import Icon from '../../atoms/Icon/Icon.component'
import SearchInput from '../../molecules/SearchInput/SearchInput.component'
import { ResourceHubLandingViewProps } from '../../../models/organisms/ResourceHub'
import { ResourceCategory } from '../../../types/ResourceHub'
import * as S from './ResourceHub.styles'

const CATEGORY_ORDER: ResourceCategory[] = [
  'safetyDatasheet',
  'technicalSheet',
  'caseStudy',
  'whitepaper',
  'certification',
]

const ResourceHubLandingView: React.FC<ResourceHubLandingViewProps> = ({
  filters,
  onFilterSelect,
  onSearch,
  onOpenFiltersModal,
  colorScheme,
}) => {
  const t = useTranslations('resourceHub')
  const categoryGroupLabelId = useId()

  const availableCategories = filters?.resourceCategory ?? []

  return (
    <S.ResourceHubLanding>
      <S.ResourceHubSearchWrapper>
        <SearchInput
          label={t('searchLabel')}
          submitButtonLabel={t('submitSearch')}
          placeholder={t('searchPlaceholder')}
          onSearch={onSearch}
        />
        <S.FilterIconButton 
          type="button"
          onClick={onOpenFiltersModal}
          aria-label={t('openFilters')}
          colorScheme={colorScheme}
        >
          <Icon name="filters" aria-hidden />
        </S.FilterIconButton>
      </S.ResourceHubSearchWrapper>

      <div>
        <S.ResourceHubCategoryLabel id={categoryGroupLabelId}>
          <Paragraph typo="paragraphMD" content={t('searchByType')} />
        </S.ResourceHubCategoryLabel>

        <S.ResourceHubCategories colorScheme={colorScheme} role="group" aria-labelledby={categoryGroupLabelId}>
          {CATEGORY_ORDER.filter((cat) => availableCategories.includes(cat)).map(
            (category) => (
              <Button
                inheritedColorScheme={colorScheme}
                key={category}
                variant="secondary"
                iconStart={category}
                label={t(`categories.${category}`)}
                handleClick={() => onFilterSelect(category)}
              />
            )
          )}
        </S.ResourceHubCategories>
      </div>
    </S.ResourceHubLanding>
  )
}

export default ResourceHubLandingView
